import { inject, Injectable } from '@angular/core';
import { IFreightBasicForCarrier, IFreightBasicForShipper } from '@okcargo-apps/shared-domain';
import { DocumentQueryService } from '@okcargo-apps/shared-infrastructure';
import { DownloadDocumentService } from '../download-document/download-document.service';

@Injectable({
  providedIn: 'root',
})
export class FreightDocumentationService {
  private readonly documentQueryService = inject(DocumentQueryService);
  private readonly downloadDocumentService = inject(DownloadDocumentService);

  public async downloadLoadingOrder(
    freight: IFreightBasicForCarrier | IFreightBasicForShipper,
    viewPrices: boolean,
  ): Promise<void> {
    const url = this.documentQueryService.getLoadingOrderUrl(freight, viewPrices);
    const filename = `loadingOrder_${freight.reference}`;

    await this.downloadDocumentService.downloadFile(url, filename);
  }

  public async downloadEcmr(freight: IFreightBasicForCarrier | IFreightBasicForShipper): Promise<void> {
    const url = this.documentQueryService.getECmrUrl(freight);
    const filename = `eCMR_${freight.reference}`;

    await this.downloadDocumentService.downloadFile(url, filename);
  }

  public async downloadDigitalControlDoc(freight: IFreightBasicForCarrier): Promise<void> {
    const url = this.documentQueryService.getDigitalControlDocUrl(freight);
    const filename = `deca_${freight.reference}`;

    await this.downloadDocumentService.downloadFile(url, filename);
  }
}
